export interface FormatClaimRequest {
    /** 任务ID */
    task_id: string;
}

export interface FormatClaimResponse {
    /** 格式化之后的权利要求 */
    formatted_claim: string;
}

export const FormatClaimApi = Symbol.for('FormatClaimApi');

export interface FormatClaimApi {
    formatClaim(data: FormatClaimRequest, options?: { single: AbortSignal }): Promise<FormatClaimResponse>;
}
